import { capitalize } from '../../index.js';
import { SCOPE_TYPE_RULES } from '../../pricing/index.js';
import { isSet } from './is-set.js';
import { SCOPE_ARTICLE } from './scope-article.js';
// WHY: scopeTypeId is derived server-side (derivePriceScopeType), never user-supplied, so an unrecognized value has no matching SCOPE_TYPE_RULES entry and is left for the DB's own chk_price_rule_scope to reject
export function refinePriceRuleScope(value, ctx) {
    const rule = SCOPE_TYPE_RULES.find((entry) => entry.scopeTypeId === value.scopeTypeId);
    if (!rule)
        return;
    const customerSet = isSet(value.customerId);
    const productSet = isSet(value.productId);
    if (rule.customerRequired && !customerSet) {
        ctx.addIssue({
            code: 'custom',
            message: `Customer is required for ${SCOPE_ARTICLE[rule.scopeTypeId]} ${rule.label} rule.`,
            path: ['customerId'],
        });
    }
    else if (!rule.customerRequired && customerSet) {
        ctx.addIssue({
            code: 'custom',
            message: `${capitalize(rule.label)} rules cannot target a customer.`,
            path: ['customerId'],
        });
    }
    if (rule.productRequired && !productSet) {
        ctx.addIssue({
            code: 'custom',
            message: `Product is required for ${SCOPE_ARTICLE[rule.scopeTypeId]} ${rule.label} rule.`,
            path: ['productId'],
        });
    }
    else if (!rule.productRequired && productSet) {
        ctx.addIssue({
            code: 'custom',
            message: `${capitalize(rule.label)} rules cannot target a product.`,
            path: ['productId'],
        });
    }
}
//# sourceMappingURL=scope-refine.js.map